export default "/images/vendor/flag-icon-css/flags/4x3/si.svg?e0de0e96aded64134bcff3acacc00a43";